import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('kba_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      // token invalid; clear locally so guards redirect
      const path = window.location.pathname;
      if (!path.startsWith('/login') && !path.startsWith('/register') && path !== '/') {
        localStorage.removeItem('kba_token');
        localStorage.removeItem('kba_user');
      }
    }
    return Promise.reject(err);
  }
);

export const RAZORPAY_BASE_URL = process.env.REACT_APP_BACKEND_URL;

// Uploaded images (POST /admin/media) are stored as "/api/media/<id>" paths,
// relative to the backend; external photo links are already absolute.
export const mediaUrl = (url) =>
  url && url.startsWith('/api/') ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;
